module.exports = __webpack_public_path__ + "static/media/ir.c59be171.svg";